module.exports = __webpack_public_path__ + "media/images/snack-logo-bd714226569510e34de330ba7c6c922a.svg";